import {
  Button,
  Label,
  SingleDatePicker,
} from '@sede-enterprise/shell-ds-react-framework';
import {
  ChevronLeft,
  ChevronRight,
} from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { DYNATRACE_ACTIONS } from 'constants/dynatrace-actions';
import { addDays, subDays } from 'date-fns';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import {
  ButtonWrapper,
  DateSelectorWrapper,
} from 'pages/Optimisation/components/DateSelector/DateSelector.styled';
import { DateSelectorProps } from 'pages/Optimisation/components/DateSelector/DateSelector.types';
import { MobileCalendarDrawer } from 'pages/Optimisation/components/mobile/MobileCalendarDrawer';
import { useStore } from 'store';
import { dynatraceTrackInstantAction } from 'utils/dynatrace';

dayjs.extend(weekday);
dayjs.extend(localeData);

const DateSelector = ({
  isMobile,
  disabled,
  error,
  loading,
  cellRender,
}: DateSelectorProps) => {
  const currentDate = useStore((state) => state.currentDate);
  const [setCurrentDate, setMobileCalendarOpen, mobileCalendarOpen] = useStore(
    (state) => [
      state.setCurrentDate,
      state.setMobileCalendarOpen,
      state.mobileCalendarOpen,
    ],
  );

  const dateChangeHandler = (value: any, dateString: string) => {
    dynatraceTrackInstantAction(DYNATRACE_ACTIONS.SWITCH_DATE_VIA_CALENDAR);
    setCurrentDate(dayjs(dateString).toDate());
  };

  const selectPreviousDay = () => {
    dynatraceTrackInstantAction(DYNATRACE_ACTIONS.SWITCH_DATE_BACKWARD);
    setCurrentDate(subDays(currentDate, 1));
  };
  const selectNextDay = () => {
    dynatraceTrackInstantAction(DYNATRACE_ACTIONS.SWITCH_DATE_FORWARD);
    setCurrentDate(addDays(currentDate, 1));
  };
  if (!currentDate) {
    return null;
  }

  return (
    <DateSelectorWrapper>
      {isMobile ? (
        <>
          <Button
            iconOnly={true}
            icon={<ChevronLeft />}
            disabled={disabled}
            onClick={selectPreviousDay}
            variant={'outlined'}
            style={{ minWidth: '40px' }}
          />
          <SingleDatePicker
            style={{ width: `${isMobile ? '100%' : '298px'}` }}
            disabled={disabled}
            invalid={Boolean(error)}
            showToday={true}
            allowClear={false}
            config={'default'}
            open={false}
            elevation={false}
            value={dayjs(currentDate)}
            onClick={setMobileCalendarOpen}
          />
          <Button
            iconOnly={true}
            icon={<ChevronRight />}
            disabled={disabled}
            onClick={selectNextDay}
            variant={'outlined'}
            style={{ minWidth: '40px' }}
          />
        </>
      ) : (
        <>
          <Label style={{ color: '#757575' }}>Day</Label>
          <SingleDatePicker
            style={{ width: `${isMobile ? '100%' : '298px'}` }}
            disabled={disabled}
            invalid={Boolean(error)}
            showToday={true}
            allowClear={false}
            config={'default'}
            value={dayjs(currentDate)}
            onChange={dateChangeHandler}
            cellRender={cellRender}
          />

          <ButtonWrapper>
            <Button
              iconOnly={true}
              icon={<ChevronLeft />}
              disabled={disabled}
              onClick={selectPreviousDay}
              variant={'outlined'}
            />
            <Button
              iconOnly={true}
              icon={<ChevronRight />}
              disabled={disabled}
              onClick={selectNextDay}
              variant={'outlined'}
            />
          </ButtonWrapper>
        </>
      )}
      {isMobile && mobileCalendarOpen ? (
        <MobileCalendarDrawer cellRender={cellRender} />
      ) : null}
    </DateSelectorWrapper>
  );
};

export default DateSelector;
